const ErpSystem = {
    Unknown: 0,
    BusinessCentral: 1,
    Emce: 2
};

export default ErpSystem;
